<script>
export default {
    name: "CancelledUnpostedBillsTab",

}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="w-full overflow-auto">
            <table class="table table-hover">
                <thead class="bg-blue-500 text-sm text-white">
                    <tr class="w-full flex">
                        <th class="p-tiny flex-1">ID</th>
                        <th class="p-tiny flex-1">Patient</th>
                        <th class="p-tiny flex-1">IP No</th>
                        <th class="p-tiny flex-1">OP No</th>
                        <th class="p-tiny flex-1">Amount</th>
                        <th class="p-tiny flex-1">Select</th>
                    </tr>
                </thead>
                <tbody class="bg-gray-100 text-xs flex flex-col items-center" style="max-height:55vh;">
                    <tr class="w-full flex">
                        <td class="p-tiny flex-1"></td>
                        <td class="p-tiny flex-1"></td>
                        <td class="p-tiny flex-1"></td>
                        <td class="p-tiny flex-1"></td>
                        <td class="p-tiny flex-1"></td>
                        <td class="p-tiny flex-1"></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="md:w-3/4 sm:w-full p-1">
            <label for="grid-cancel-memo" class="label-control">Memo</label>
            <textarea id="grid-cancel-memo" cols="30" rows="2" class="input-sm input-control text-xs"></textarea>
        </div>
        <div class="md:w-1/4 sm:w-full p-1">
            <h5 class="text-right font-bold mt-3">Total Amount: <span class="text-blue-500">0.00</span></h5>
        </div>
        <div class="w-full p-1 bg-gray-300 border-2 text-right rounded">
            <button class="btn-primary btn-sm text-xs rounded"><i class="fa fa-save"></i> Bulk Approve</button>
        </div>
    </div>
</template>